import { paymentSectionNew } from "./sections/payment_new.js";
import { CLAIM_CURRENCY_INPUT_WIDTH } from "./formDefConstants.js";

const SCHADEN_DESC =
  "Die Frage, 'Was ist passiert?', ist entscheidend, um den Versicherungsschaden korrekt zu bearbeiten. Bitte beschreiben Sie den Vorfall so ausführlich wie möglich. Wo und wann ist er passiert? Welche Umstände haben dazu geführt? Welche Schäden sind aufgetreten? Ihre genaue Beschreibung hilft dem Versicherer, den Schadensfall effizient zu prüfen und die Ansprüche Ihres Mandante zu bearbeiten. Je mehr Informationen Sie bereitstellen, desto besser kann der Versicherer Ihren Schaden prüfen.";

const ALLES_KORREKT_LABEL =
  "Die vorstehenden Angaben habe(n) ich/wir wahrheitsgetreu und nach bestem Wissen und Gewissen gemacht. Der Versicherungsnehmer ist für die Richtigkeit der Angaben verantwortlich, auch wenn eine andere Person ihre Niederschrift vornimmt. Bewusst unwahre oder unvollständige Angaben führen auch dann zum Verlust des Versicherungsschutzes, wenn dem Versicherer dadurch kein Nachteil entsteht. Der Versicherer ist bevollmächtigt, bei Behörden in alle diesen Vorfall betreffenden Akten einzusehen und ggf. Abschriften anzufertigen. Wir sind damit einverstanden, dass die Abwicklung ohne vorherige Information ggf. direkt mit den Geschädigten erfolgen kann.";

export const fdefFormINew = {
  __renderer: "new",
  formdefinition: [
    {
      control: "info",
      title: "Sie melden nachfolgend einen Haftpflichtschaden",
      description:
        "In diesem Zusammenhang raten wir Ihnen: Erkennen Sie Haftpflichtansprüche nicht an und leisten Sie keine Zahlungen. Beauftragen Sie von sich aus keinen Rechtsanwalt. Die Anwaltsbestellung und die Prozessführung sind Aufgabe des Versicherers. Dies gilt nicht für Strafverfahren und eigene Ansprüche. Gegen Mahnbescheide bitte sofort Widerspruch erheben!",
    },
    {
      control: "stepper",
      name: "schadensmeldung",
      label: "Schadenanzeige - Allgemeine Haftpflicht",
      showSubformErrorCount: false,
      cols: "12",
      steps: [
        {
          label: "Vertragsdaten",
          description: "Der Schaden wird für folgenden Vertrag gemeldet.",
          children: [
            { control: "input", name: "vertragsnummer", label: "Vertragsnummer", disabled: true, cols: "6" },
            { control: "input", name: "gesellschaft", label: "Gesellschaft", disabled: true, cols: "6" },
          ],
        },
        {
          label: "Schaden",
          description: SCHADEN_DESC,
          children: [
            { control: "input", name: "schaden_nummer_kd", label: "eigene Vorgangsnummer", cols: "12" },
            {
              control: "datepicker",
              name: "schaden_datum",
              label: "Schadensdatum",
              valid: [{ fn: "required" }, { fn: "max_date_today", message: "Das Schadensdatum darf nicht in der Zukunft liegen." }],
              cols: "6",
            },
            { control: "timepicker", name: "schaden_uhrzeit", label: "Uhrzeit", cols: "6" },
            { control: "switch", name: "grossschaden", label: "Großschaden", cols: "12" },
            { control: "textarea", name: "schaden_ort", label: "Schadenort", cols: "12" },
            { control: "textarea", name: "schaden_adresszusatz", label: "Adresszusatz", cols: "12" },
            { control: "textarea", name: "schaden_schilderung", label: "Schilderung des Hergangs", cols: "12", valid: [{ fn: "required" }] },
            {
              control: "autocomplete",
              name: "schaden_ursache",
              label: "Ursache des Schadens",
              cols: "12",
              valid: [{ fn: "required" }],
              get_api: { endpoint: "data/schaden_ursachen_select", map_result: { key: "id", label: "label" } },
            },
            { control: "switch", name: "schaden_personenschaden", label: "eine Person wurde geschädigt", cols: "12" },
            { control: "sbwarning", betrag: ["schaden_rechnungsbetrag", "schaden_kostenvoranschlag", "schaden_hoehe"] },
            {
              control: "numberinput",
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_hoehe",
              label: "Schadenhöhe (eigene Schätzung)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: { xxl: 4 },
              valid: [{ fn: "required_when", field: "grossschaden", equals: true }],
            },
            {
              control: "numberinput",
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_kostenvoranschlag",
              label: "Schadenhöhe (Kostenvoranschlag)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: { xxl: 4 },
            },
            {
              control: "numberinput",
              unit_type: "currency",
              unit: "€",
              allow_negative: false,
              name: "schaden_rechnungsbetrag",
              label: "Schadenhöhe (Rechnung)",
              input_width: CLAIM_CURRENCY_INPUT_WIDTH,
              cols: { xxl: 4 },
            },
            { control: "switch", name: "schaden_abtretungserklärung", label: "Abtretungserklärung liegt vor ja/nein", cols: "12" },
            { control: "input", name: "schaden_verursacher", label: "Verursacher (Name und Anschrift)", cols: "12" },
          ],
        },
        {
          label: "Polizei",
          description: "Falls der Unfall polizeilich aufgenommen wurde, benötigen wir weitere Details.",
          children: [
            { control: "switch", name: "polizei_aufgenommen", label: "polizeiliche Aufnahme ist erfolgt", cols: "12" },
            {
              control: "input",
              name: "polizei_dienststelle",
              label: "Dienststelle",
              cols: "12",
              hidden: { when: { field: "polizei_aufgenommen", truthy: false } },
            },
            {
              control: "input",
              name: "polizei_tagebuchnummer",
              label: "Aktzenzeichen/Tagebuchnummer",
              cols: "12",
              hidden: { when: { field: "polizei_aufgenommen", truthy: false } },
            },
          ],
        },
        paymentSectionNew,
        {
          label: "Unfallgegner/Geschädigte Person",
          description: SCHADEN_DESC,
          children: [
            { control: "input", name: "geschaedigte_person_vorname", label: "Vorname", cols: "6" },
            { control: "input", name: "geschaedigte_person_name", label: "Nachname/Firma", cols: "6", valid: [{ fn: "required" }] },
            { control: "datepicker", name: "geschaedigte_person_geburtsdatum", label: "Geburtsdatum", cols: "4" },
            { control: "input", name: "geschaedigte_person_strasse", label: "Strasse", cols: "8", valid: [{ fn: "required" }] },
            { control: "input", name: "geschaedigte_person_hausnummer", label: "Hausnummer", cols: "2", valid: [{ fn: "required" }] },
            { control: "input", name: "geschaedigte_person_land", label: "Land", cols: "2" },
            { control: "input", name: "geschaedigte_person_plz", label: "PLZ", cols: "4", valid: [{ fn: "required" }] },
            { control: "input", name: "geschaedigte_person_ort", label: "Ort", cols: "8", valid: [{ fn: "required" }] },
            { control: "input", name: "geschaedigte_person_telefon", label: "Telefon", cols: "6" },
            { control: "input", name: "geschaedigte_person_email", label: "E-Mail", cols: "6" },
            {
              control: "input",
              name: "geschaedigte_person_beruf_arbeitgeber",
              label: "Beruf/Arbeitgeber",
              cols: "12",
              hidden: { when: { field: "schaden_personenschaden", equals: false } },
            },
            {
              control: "input",
              name: "geschaedigte_person_krankenkasse",
              label: "Krankenkasse",
              cols: "12",
              hidden: { when: { field: "schaden_personenschaden", equals: false } },
            },
            {
              control: "switch",
              name: "geschaedigte_person_arbeitsunfall",
              label: "Arbeitsunfall",
              cols: "6",
              hidden: { when: { field: "schaden_personenschaden", equals: false } },
            },
            {
              control: "switch",
              name: "geschaedigte_person_wegunfall",
              label: "Wegunfall",
              cols: "6",
              hidden: { when: { field: "schaden_personenschaden", equals: false } },
            },
            {
              control: "input",
              name: "geschaedigte_person_arzt_krankenhause",
              label: "Behandelnder Arzt/Krankenhaus",
              cols: "12",
              hidden: { when: { field: "schaden_personenschaden", equals: false } },
            },
          ],
        },
        {
          label: "Ansprechpartner",
          description: "",
          children: [
            { control: "input", name: "ansprechpartner_vorname", label: "Vorname", cols: "6" },
            { control: "input", name: "ansprechpartner_name", label: "Nachname", cols: "6", valid: [{ fn: "required" }] },
            { control: "input", name: "ansprechpartner_telefon", label: "Telefon", cols: "6", valid: [{ fn: "required" }] },
            { control: "input", name: "ansprechpartner_mobil", label: "Mobilnummer (wird bevorzugt)", cols: "6" },
            { control: "input", name: "ansprechpartner_email", label: "E-Mail", valid: [{ fn: "required" }, { fn: "email" }], cols: "6" },
          ],
        },
        {
          label: "Anhänge",
          description: "",
          children: [
            {
              control: "claim_attachments",
              name: "sonstiges_unterlagen",
              label: "z.B. Farbfotos inkl. Kennzeichen, Kostenvoranschlag, Reparaturrechnung; maximale Größe von 15MB. Ohne Rechnungen und Schadenfotos kann der Schaden nicht zur Prüfung gemeldet werden",
              multiple: true,
              add_description: true,
              show_other_field_files: true,
              prevent_selecting_other_field_files: true,
              cols: "12",
            },
            { control: "info", title: "Welche Unterlagen haben Sie hochgeladen?", description: "Diese Liste dient zur Überprüfung" },
            {
              label: "Schadenfotos",
              description: "Bitte übermitteln Sie uns Fotos des Schadens. Diese helfen uns, den Schaden schneller und besser zu prüfen.",
              control: "radiogroup",
              name: "schadenfotos",
              cols: "12",
              valid: [{ fn: "required" }],
              options: [
                { key: "hochgeladen", label: "hochgeladen" },
                { key: "Schaden_bereits_behoben", label: "Schaden bereits behoben" },
                { key: "Erstellung_nicht_moeglich", label: "Erstellung nicht möglich" },
              ],
            },
            { label: "Kostenvoranschlag/Rechnung", control: "checkbox", name: "kostenvoranschlag", valid: [{ fn: "must_be_true", message: "Kostenvoranschlag oder Rechnung sollte hochgeladen werden" }], default: false },
            { label: "Leckortungsbericht", control: "checkbox", name: "leckortungsbericht" },
            { label: "Abtretungserklärung", control: "checkbox", name: "abtretungserklaerung" },
          ],
        },
        {
          label: "Abschluß",
          description: "",
          children: [
            {
              control: "switch",
              name: "alles_korrekt",
              label: ALLES_KORREKT_LABEL,
              cols: "12",
              valid: [{ fn: "must_be_true", message: "Die Bestätigung ist verpflichtend" }],
            },
          ],
        },
      ],
    },
  ],
  transformIn: [
    { fn: "copyIfEmpty", source: "bezeichnung", target: "schaden_ort" },
    { fn: "copyIfEmpty", source: "user.vorname", target: "ansprechpartner_vorname" },
    { fn: "copyIfEmpty", source: "user.nachname", target: "ansprechpartner_name" },
    { fn: "copyIfEmpty", source: "user.telefon", target: "ansprechpartner_telefon" },
    { fn: "copyIfEmpty", source: "user.email", target: "ansprechpartner_email" },
  ],
};
